import { render, staticRenderFns } from "./normalTable.vue?vue&type=template&id=5372fdaa&"
import script from "./normalTable.vue?vue&type=script&lang=js&"
export * from "./normalTable.vue?vue&type=script&lang=js&"
import style0 from "./normalTable.vue?vue&type=style&index=0&id=5372fdaa&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports